import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/constants";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.role !== "admin") {
        await api.post("/auth/logout");
        setErr("This account does not have admin access.");
        setBusy(false);
        return;
      }
      setUser(data);
      navigate("/admin");
    } catch (e2) {
      setErr(apiError(e2));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-[#0B0F0D] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md bg-white/[0.04] border border-white/10 rounded-2xl p-8 backdrop-blur-md">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="" className="h-10 w-10 rounded-full object-cover" />
          <div>
            <p className="text-[10px] font-bold tracking-[0.16em] text-[#D4AF37] uppercase">Universal Short-Command Prompt Dictionary™</p>
            <h1 className="font-display text-xl font-bold text-white flex items-center gap-2">Admin Login <ShieldCheck size={17} className="text-emerald-400" /></h1>
          </div>
        </div>
        <p className="text-sm text-gray-400 mt-3">Restricted area. For site administrators only.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="admin-login-email-input" type="email" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[#D4AF37]" />
          <input data-testid="admin-login-password-input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[#D4AF37]" />
          {err && <p data-testid="admin-login-error" className="text-sm text-red-400">{err}</p>}
          <button data-testid="admin-login-submit-btn" disabled={busy}
            className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 font-bold py-3 rounded-xl active:scale-[0.98] transition-all disabled:opacity-60">
            {busy ? "Logging in…" : "Log in to Admin"}
          </button>
        </form>
      </div>
    </div>
  );
}
